import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useAppData } from '../../../contexts/appData';
import { css } from '../../../utils/css';
import { Header } from '../../shared/header/header';
import { Icon } from '../../shared/icons/icon';
import { UserInfo } from './../../../models/userInfo';
import { useApi } from './../../../utils/api';
import { CurrentPages } from './currentPages/currentPages';
import { NewPage } from './newPage/newPage';
import { ResponderStaff } from './responderStaff/responderStaff';
import styles from './workRequests.module.css';


export const WorkRequests: FC = () => {

    const { department } = useParams();
    const [currentPage, setCurrentPage] = useState('requests');

    const [loadingResponders, setLoadingResponders] = useState(false);
    const [responders, setResponders] = useState<UserInfo[]>([]);

    const api = useApi();

    const {
        departments,
        selectedSite,
    } = useAppData();

    useEffect(() => {
        setLoadingResponders(true);
        api.get<UserInfo[]>('users/active', {
            department: department ?? '',
            site: selectedSite?.id.toString()!,
        }).then(json => {
            setLoadingResponders(false);
            setResponders(json);
        }).catch(ex => {
            setLoadingResponders(false);
        })
    }, [department, selectedSite]);

    const departmentInfo = () => departments.find(d => d.id.toString() === department);


    return <section className={styles.WorkRequests}>
        <section className={styles.Tabs}>
            <button
                onClick={() => setCurrentPage('requests')}
                className={css(styles.Tab, currentPage === 'requests' && styles.Active)}
            >
                Requests
            </button>
            <button
                onClick={() => setCurrentPage('newPage')}
                className={css(styles.Tab, currentPage === 'newPage' && styles.Active)}
            >
                New Page
            </button>
            <button
                onClick={() => setCurrentPage('responderStaff')}
                className={css(styles.Tab, currentPage === 'responderStaff' && styles.Active)}
            >
                Responder Staff
            </button>
        </section>
        <main className={css(styles.TabContent, currentPage === 'requests' && styles.Active)}>
            <Header
                className={styles.IconHeader}
                icon={<Icon src={departmentInfo()?.icon} />}
            >
                <b>{departmentInfo()?.name ?? '?'}</b>: Current Pages
            </Header>
            <CurrentPages />
        </main>
        <section className={css(styles.TabContent, currentPage === 'newPage' && styles.Active)}>
            <NewPage department={departmentInfo()} responders={responders} />
        </section>
        <section className={css(styles.TabContent, currentPage === 'responderStaff' && styles.Active)}>
            <ResponderStaff responders={responders} loading={loadingResponders} />
        </section>
    </section>
}

